/*
/	Corentin BOUTON — Junior Mines Provence 2023
/	contact@junior-mines-provence.fr
/	https://junior-mines-provence.fr
*/

import { Stack, ButtonGroup, ToggleButton, Image } from 'react-bootstrap';

import { Titre, Item } from '../Fonctions';

/// Commandes
const cordelette = "https://firebasestorage.googleapis.com/v0/b/configurateur-store-vision.appspot.com/o/cordelette.webp?alt=media&token=47f075c2-4ff3-4634-b307-3b2804b3554c";
const slide = "https://firebasestorage.googleapis.com/v0/b/configurateur-store-vision.appspot.com/o/slide.webp?alt=media&token=5e73cc30-d443-4862-9b5a-1ef8041b7db1";
const moteur_lames = "https://firebasestorage.googleapis.com/v0/b/configurateur-store-vision.appspot.com/o/moteur_lames.webp?alt=media&token=2ba6fb5f-3993-47db-b115-9f28a5ab3102";
const moteur_blackout = "https://firebasestorage.googleapis.com/v0/b/configurateur-store-vision.appspot.com/o/moteur_blackout.webp?alt=media&token=a459b1cd-6779-42a7-83f7-9e9da50c1e2b";

function Commande({ commande, setCommande, store_type }) {
	const debug = false;

	return (
		<Stack gap={2}>
			<Titre>Type de commande</Titre>
			<ButtonGroup style={{ width: '95%' }}>
			{store_type === 0 ?
				<ToggleButton
					id='slide'
					type="radio"
					variant={'outline-dark'}
					name="slide"
					checked={commande === 0}
					onClick={(e) => setCommande(0)}>
					<Stack gap={2}>
						<Item>Manuelle</Item>
						Cordelette
						<Image src={cordelette} rounded style={{ width: '40%', display: 'block', margin: 'auto' }} alt='cordelette-img'/>
					</Stack>
				</ToggleButton> :
				<ToggleButton
					id='slide'
					type="radio"
					variant={'outline-dark'}
					name="slide"
					checked={commande === 1}
					onClick={(e) => setCommande(1)}>
					<Stack gap={2}>
						<Item>Manuelle</Item>
						Slide
						<Image src={slide} rounded style={{ width: '60%', display: 'block', margin: 'auto' }} alt='slide-img'/>
					</Stack>
				</ToggleButton>}
				<ToggleButton
					id='moteur'
					type="radio"
					variant={'outline-dark'}
					name="moteur"
					checked={commande === 2}
					onClick={(e) => setCommande(2)}>
					<Stack gap={2}>
						<Item>Moteur solaire</Item>
						Panneau solaire et batteries intégrées
						<Image src={store_type ? moteur_blackout : moteur_lames} rounded style={{ width: '60%', display: 'block', margin: 'auto' }} alt='moteur-img'/>
					</Stack>
				</ToggleButton>
			</ButtonGroup>
			{debug ? commande : null}
		</Stack>
	);
}

export default Commande;
